const s = require("./menuItem.module.scss");

import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink } from "react-router-dom";
import classnames from "classnames";

interface MenuItemProps {
    route: string;
    title: string;
    icon?: IconDefinition;
    style?: React.CSSProperties;
}

const MenuItem = ({ route, title, icon, style }: MenuItemProps) =>
    <NavLink to={route} activeClassName={s.active} className={icon === undefined ? s.menuItem : classnames(s.menuItem, s.menuIcon)}>
        {icon && <FontAwesomeIcon icon={icon} />}
        <span style={style}>{title}</span>
    </NavLink>;

export default MenuItem;